import { Grid } from "@mui/material";
import { Toast } from "components/ui";
import StockCard from "components/ui/StockCard";
import { useGlobalContext } from "context/GlobalContext";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import "./product.css";
import useStockInCatalog from "hooks/useStockInCatalog";
import useProductInCatalogCheck from "hooks/useStockInCatalog";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, addToMeltingCart, initCart, removeFromCart, removeFromMeltingCart } from "store/cartSlice";
const Product = React.memo(({ product, allData }) => {
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const isEditCatagory = location?.state?.isEditCatagory;
  const updateCatagoryData = location?.state?.updateCatagory;
  const isMeltingStock = location?.state?.newName === "Create Melting Stock"; // Check for Melting Stock Flow

  const [open, setOpen] = useState(false);

  const { setBtnTitle, btnTitle, presentInCatalog } = useStockInCatalog(product, isEditCatagory || isMeltingStock, updateCatagoryData);

  const dispatch = useDispatch();

  const isInCart = useSelector(
    (state) =>
      state.cart.cartData.some(
        (item) => item.styleNumber === product.styleNumber
      )
  );
  const isMeltingInCart = useSelector(
    (state) =>
      state.cart.cartData.some(
        (item) => item.jewelCode === product.jewelCode
      )
  );
  const selectedCartProducts = useMemo(
    () => ({
      ...product,
      isAddedInCart: true,
    }),
    [product]
  );

  const handleAddToCartBtn = React.useCallback(() => {
    if (isMeltingStock) {
      dispatch(addToMeltingCart(selectedCartProducts));
    } else {
      // dispatch(addToCart(selectedCartProducts));
      dispatch(addToCart({
        product: selectedCartProducts,
        location: location,
      }));
    }
  }, [dispatch, selectedCartProducts, isMeltingStock]);

  const handleRemoveCart = React.useCallback(() => {
    if (isMeltingStock) {
      dispatch(removeFromMeltingCart(selectedCartProducts));
    } else {
      dispatch(removeFromCart(selectedCartProducts));
    }
  }, [dispatch, selectedCartProducts, isMeltingStock]);

  useEffect(() => {
    setBtnTitle(
      isMeltingStock
        ? (isMeltingInCart ? "Selected" : "Select")
        : (isInCart ? "Added" : "Add")
    );
  }, [isInCart, setBtnTitle, isMeltingStock, isMeltingInCart]);

  useEffect(() => {
    dispatch(initCart());
  }, [dispatch]);

  const handleClose = useCallback((reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  }, []);

  return (
    <>
      <Grid item className="stock">
        <StockCard
          data={product}
          selectedCartProducts={selectedCartProducts}
          {...(innerChnages && {
            isBtn: true,
            addtoCart: handleAddToCartBtn,
            removeCart: handleRemoveCart,
            btnTilte: isMeltingStock ? (isMeltingInCart ? "Selected" : "Select") : btnTitle,
            presentInCatalog: presentInCatalog,
          })}
          allData={allData}
        />
      </Grid>
    </>
  );
});

export default React.memo(Product);